import { Helper } from "../../utils";

const ViewEmbedJS = ({ data }) => {
    const {
        createdAt,
        embedJsKey,
        embedJs,
        demandNo,
        publishStatus,
        modifiedDate,
        publishUpdateDate,
    } = data;

    return (
        <>
            <h5 className="mb-3">Embed JS Configuration</h5>
            <div className="info-table">
                <div className="row info-table__tr mb-2">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">
                                <label>Embed JS Key</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{embedJsKey}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">
                                <label>Demand No</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{demandNo}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row info-table__tr mb-2">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">
                                <label>Status</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{publishStatus ? "Published" : "Unpublished"}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">
                                <label>Published At</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{Helper.formatDate(publishUpdateDate)}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-table__tr mb-2">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">
                                <label>Created By</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>
                                        <a href={`mailto:${data.createdAtBy.email}`}>
                                            {data.createdAtBy.firstName} {data.createdAtBy.lastName}
                                        </a>
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">
                                <label>Modified By</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>
                                        {" "}
                                        <a href={`mailto:${data.modifiedBy.email}`}>
                                            {data.modifiedBy.firstName} {data.modifiedBy.lastName}
                                        </a>
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row info-table__tr mb-2">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">
                                <label>Created At</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{Helper.formatDate(createdAt)}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">
                                <label>Modified Date</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{Helper.formatDate(modifiedDate)}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-2 mb-2">
                    <label>Embed JS Code</label>

                    <div className="card p-0" style={{ maxWidth: "992px", maxHeight: "300px" }}>
                        <pre className="mb-0 p-3">
                            <code>{embedJs}</code>
                        </pre>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewEmbedJS;
